/**
 * Kind vocabulary. The server never rejects an unknown kind — these are the ones the typed views
 * understand. Everything Harness.log writes on the device also arrives as `harness.<kind>`.
 */
export const K = {
    deviceHello: "device.hello",
    deviceSettings: "device.settings",
    runStart: "run.start",
    runStep: "run.step",
    runEnd: "run.end",
    runStop: "run.stop",
    loopInstall: "loop.install",
    loopKill: "loop.kill",
    loopTick: "loop.tick",
    feedSample: "feed.sample",
    modelQuery: "model.query",
    screenObserve: "screen.observe",
    screenShot: "screen.shot",
    graphState: "graph.state",
    graphEdge: "graph.edge",
    graphEdgeRemove: "graph.edge.remove",
    graphSnapshot: "graph.snapshot",
    capabilityLearned: "capability.learned",
    capabilityHeal: "capability.heal",
    capabilityQuarantine: "capability.quarantine",
    telemetryDropped: "telemetry.dropped",
    telemetryGap: "telemetry.gap",
};
/** Namespace of a kind (`graph.state` → `graph`), used for colouring. */
export function kindNamespace(kind) {
    const i = kind.indexOf(".");
    return i < 0 ? kind : kind.slice(0, i);
}
//# sourceMappingURL=kinds.js.map